import React, {useEffect, useRef} from 'react';
import Text from './question_types/_Text';
import Radio from './question_types/_Radio';
import MultiSelect from './question_types/_MultiSelect';
import { shouldShow } from "../utils/filterable";
import ReactGA from 'react-ga';

function Question(props: any) {
  
  const question = props.question

  const moveToNext = () => {
    ReactGA.event({
      category: 'Quiz Progress',
      action: 'Completed Question',
      value: props.questionIndex + 1
    });
    props.setQuestionIndex(props.questionIndex + 1)
  }


   useEffect( () => {
    if (question?.custom_module_condition && !shouldShow(question?.custom_module_condition, props.values)) {
      moveToNext();
    }
    }, [props.questionIndex])

 
    
  return (
      <>
      <div className="question-container">
        <h2 className="question-title">
          {question.label }
        </h2>
        { question.mod_type === "radio" ?
        <Radio baseName={props.baseName} moveToNext={moveToNext} question={question} /> :
        question.mod_type === "checkbox" ?
          <MultiSelect baseName={props.baseName} moveToNext={moveToNext} question={question} /> :
        question.mod_type === "label" ?
        null
        : <Text baseName={props.baseName} moveToNext={moveToNext} question={question} /> }
      </div>
      </>
  );
}

export default Question;
